var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowLeftWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / arrow left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 12C4.00006 11.7348 4.10545 11.4805 4.293 11.293L10.293 5.29302C10.4816 5.11086 10.7342 5.01007 10.9964 5.01235C11.2586 5.01462 11.5094 5.11979 11.6948 5.3052C11.8802 5.49061 11.9854 5.74142 11.9877 6.00362C11.99 6.26582 11.8892 6.51842 11.707 6.70702L7.414 11H19C19.2652 11 19.5196 11.1054 19.7071 11.2929C19.8946 11.4804 20 11.7348 20 12C20 12.2652 19.8946 12.5196 19.7071 12.7071C19.5196 12.8947 19.2652 13 19 13H7.414L11.707 17.293C11.8892 17.4816 11.99 17.7342 11.9877 17.9964C11.9854 18.2586 11.8802 18.5094 11.6948 18.6948C11.5094 18.8802 11.2586 18.9854 10.9964 18.9877C10.7342 18.99 10.4816 18.8892 10.293 18.707L4.293 12.707C4.10545 12.5195 4.00006 12.2652 4 12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftWhite);
export default __webpack_public_path__ + "static/media/icon-arrow-left-white.96e12c2e9722dd5283d17e6ccfac6119.svg";
export { ForwardRef as ReactComponent };